import React from 'react';
import { makeStyles } from '@material-ui/core';
import PublicLayout from '../layouts/PublicLayout';
import useSEO from '../seo/use-seo';
import StandardPageHelmet from '../seo/components/StandardPageHelmet';
import { LifestyleHeroSection } from './LifestyleTravel/LifestyleHeroSection';
import { LifestyleExperiencesSection } from './LifestyleTravel/LifestyleExperiencesSection';
import { LifestyleWhyMembersSection } from './LifestyleTravel/LifestyleWhyMembersSection';
import { LifestyleJourneyCTASection } from './LifestyleTravel/LifestyleJourneyCTASection';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    backgroundColor: '#111111',
    minHeight: '100vh',
    paddingBottom: '70px',
    color: '#fff',
  }
}));

export default function LifestyleTravelPage() {
  const classes = useStyles();
  const seo = useSEO("login"); 

  return (
    <PublicLayout>
      <StandardPageHelmet seo={seo} />
      <div className={classes.pageContainer}>
        <LifestyleHeroSection />
        <LifestyleExperiencesSection />
        <LifestyleWhyMembersSection />
        <LifestyleJourneyCTASection />
      </div>
    </PublicLayout>
  );
}
